export enum EXIT_TYPE_CHINESE {
  VOLUNTARY = '主动',
  INVOLUNTARY = '被动',
}

export enum EXIT_TYPE {
  VOLUNTARY = 'VOLUNTARY',
  INVOLUNTARY = 'INVOLUNTARY'
}
